import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Melbourne Water – Hobsons Bay Main Upgrade Project</h3>
      </div>
      <div className="popup-content-source">
      <p className="bold">
        South East Water’s Sewer Mining Pump Station, once constructed, will connect to Melbourne Water’s Hobsons Bay Sewer Main to extract the city’s wastewater to the Water Recycling Plant, where it will be treated to class A Recycled Water.
           </p>
      </div>
    </>
  );
};

export default Content;
